/**
 * Helper Class
 */
export class Helper {



	/**
	 * Add Class to element
	 *
	 * @param  {element} el
	 * @param  {string} className
	 * @return {void}
	 */
	static addClassToEl ( el, className ) {

		if ( ! el.classList.contains( className ) ) {

			el.classList.add( className )

		}

	}

	/**
	 * Remove Class from element
	 *
	 * @param  {element} el
	 * @param  {string} classToRemove
	 * @return {void}
	 */
	static removeClassFromEl( el, classToRemove ) {

		if ( el.classList.contains( classToRemove ) ) {

			el.classList.remove( classToRemove );

		}

	}

	/**
	 * Check if element has class
	 *
	 * @param {element} el
	 * @param {string} classToCheck
	 * @return {boolean}
	 */
	static hasClass = ( el, classToCheck ) => {

		return (
			el.classList.contains( classToCheck )
		)

	}

	/**
	 * Remove Class from all elements
	 *
	 * @param {element} elements
	 * @param {string}  classToRemove
	 */
	static removeClassFromAll = ( elements, classToRemove ) => {

		elements.forEach( ( el ) => {

			if ( this.hasClass( el, classToRemove ) ) {

				el.classList.remove( classToRemove );

			}

		} )

	}

	/**
	 * Add Class to all elements
	 *
	 * @param {element} elements
	 * @param {string}  classToAdd
	 */
	static addClassToAll = ( elements, classToAdd ) => {

		elements.forEach( ( el ) => {

			this.addClassToEl( el, classToAdd )

		} )

	}

	/**
	 * Stop body scroll when mobile menu is open
	 *
	 * @param {bool} bool
	 * @return {void}
	 */
	static letBodyScroll( bool ) {

		if ( bool ) {

			const scrollY = document.body.style.top;
			setTimeout( () => {

				document.body.style.position = '';
				window.scrollTo( 0, parseInt( ( scrollY + 90 ) || '0' ) * -1 );
				document.body.style.top = '';

			}, 60 );
			// this.setBodySmoothScroll( true );

		} else {


			// this.setBodySmoothScroll( false );
			const scrollY = document.documentElement.style.getPropertyValue( '--scroll-y' );
			document.body.style.position = 'fixed';
			document.body.style.top = `-${ scrollY }`;

		}

	}

	/**
	 * Set smooth body scroll
	 *
	 * @param {bool} bool
	 * @return {void}
	 */
	setBodySmoothScroll( bool ) {

		if ( bool ) {

			setTimeout( () => {

				document.documentElement.style.scrollBehavior = 'smooth';

			}, 100 );

		} else {

			document.documentElement.style.scrollBehavior = 'unset';

		}

	}

}

